export default "<svg viewBox=\"0 0 24 24\"><path d=\"M24,12A12,12,0,1,0,12,24,12,12,0,0,0,24,12ZM6,13h4V6h4v7h4l-6,6Z\"/></svg>";